export default "__VITE_ASSET__Bz0wRL0S__"